import { Button, Grid, Typography, Paper, Container } from "@mui/material";
import { Box } from "@mui/system";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const schema = yup.object().shape({
  termsAndConditions: yup
    .boolean()
    .oneOf([true], "You must accept the terms and conditions to proceed"),
});

export default function AcknowledgementandDeclaration({
  handleNext,
  handleBack,
  setGetValues,
  getValues,
}) {
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: getValues,
  });

  const onSubmit = (data) => {
    // setGetValues((prevData) => ({
    //   ...prevData,
    //   ...data,
    // }));
    handleNext();
  };

  return (
    <Container maxWidth="md" sx={{}}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography
          variant="h5"
          gutterBottom
          sx={{ fontWeight: "bold", mb: 3 }}
        >
          Terms and Conditions
        </Typography>

        <Box
          sx={{
            maxHeight: "60vh",
            overflowY: "auto",
            pr: 2,
            mb: 3,
            border: "1px solid #e0e0e0",
            borderRadius: 1,
            p: 3,
            backgroundColor: "#f9f9f9",
            textAlign: "left", // Ensure left alignment
          }}
        >
          <Typography variant="body1" paragraph sx={{ mb: 3 }}>
            These terms and conditions ("Terms") govern your participation in
            the scholarship application process administered by IDEA Non-profit.
            By submitting your scholarship application, you agree to abide by
            these Terms.
          </Typography>

          {[
            {
              title: "1. Documentation of Information",
              content:
                "All information provided by applicants will be documented and stored securely by IDEA Non-Profit org. The data submitted by applicants belongs to IDEA Non-Profit org and will be used solely for the purpose of evaluating scholarship applications.",
            },
            {
              title: "2. Scholarship Approval",
              content:
                "The approval of scholarship applications is subject to the discretion of IDEA. The approved scholarship amount may vary based on the decisions and approval of IDEA.",
            },
            {
              title: "3. Variation of Approved Amount",
              content:
                "The approved scholarship amount may vary based on the decisions and approval of IDEA. IDEA reserves the right to adjust the scholarship amount based on available funds, applicant qualifications, and other relevant factors.",
            },
            {
              title: "4. Application Review",
              content:
                "All scholarship applications will be reviewed by IDEA in a fair and unbiased manner. Applicants will be notified of the status of their application in a timely manner. Applications will be reviewed based on the Scholarship guidelines set by IDEA Education committee.",
            },
            {
              title: "5. Confidentiality",
              content:
                "IDEA will maintain confidentiality regarding all information submitted by applicants. Applicant data will not be shared with third parties without prior consent, except as required by law.",
            },
            {
              title: "6. Modification of Terms",
              content:
                "IDEA reserves the right to modify these Terms at any time without prior notice. Any changes to these Terms will be effective immediately upon posting on the IDEA website or other official channels.",
            },
            {
              title: "7. Governing Law",
              content:
                "These Terms shall be governed by and construed in accordance with the laws of [Jurisdiction]. Any disputes arising out of or in connection with these Terms shall be subject to the exclusive jurisdiction of the courts of [Jurisdiction]. By submitting your scholarship application, you acknowledge that you have read, understood, and agreed to these Terms.",
            },
          ].map((item, index) => (
            <Box key={index} sx={{ mb: 3 }}>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: "bold", mb: 1 }}
              >
                {item.title}
              </Typography>
              <Typography variant="body2" sx={{ color: "text.secondary" }}>
                {item.content}
              </Typography>
            </Box>
          ))}
        </Box>
        <Box sx={{ display: "flex", justifyContent: "end" }}>
          <FormGroup>
            <Controller
              name="termsAndConditions"
              control={control}
              render={({ field }) => (
                <FormControlLabel
                  control={
                    <Checkbox
                      {...field}
                      checked={field.value}
                      sx={{
                        color: errors.termsAndConditions
                          ? "error.main"
                          : "primary.main",
                        "&.Mui-checked": {
                          color: errors.termsAndConditions
                            ? "error.main"
                            : "primary.main",
                        },
                        mt: -1.2,
                      }}
                    />
                  }
                  label={
                    <Typography variant="body1">
                      I accept the terms and conditions
                    </Typography>
                  }
                  sx={{
                    alignItems: "flex-start",
                    "& .MuiFormControlLabel-label": {
                      marginTop: "3px",
                    },
                  }}
                />
              )}
            />
            {errors.termsAndConditions && (
              <Typography
                variant="body2"
                color="error"
                sx={{ ml: 4, mt: -1, mb: 1 }}
              >
                {errors.termsAndConditions.message}
              </Typography>
            )}
          </FormGroup>
        </Box>

        <Grid container justifyContent="space-between">
          <Grid item>
            <Button
              variant="outlined"
              onClick={handleBack}
              sx={{ minWidth: 120, textTransform: "none" }}
            >
              Back
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              onClick={handleSubmit(onSubmit)}
              sx={{ minWidth: 120, textTransform: "none" }}
              disabled={!!errors.termsAndConditions}
            >
              Next
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
}
